// @ts-check
import Modal from './Modal';
export * from './ModalHeader';

export default Modal;
